import { render, staticRenderFns } from "./MapPopup.vue?vue&type=template&id=20fda570&"
import script from "./MapPopup.vue?vue&type=script&lang=js&"
export * from "./MapPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fda570')) {
      api.createRecord('20fda570', component.options)
    } else {
      api.reload('20fda570', component.options)
    }
    module.hot.accept("./MapPopup.vue?vue&type=template&id=20fda570&", function () {
      api.rerender('20fda570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Maps/MapPopup.vue"
export default component.exports